export default __webpack_public_path__ + "static/media/grid9.581fccb4.png";